import * as api from '../connectivity/api.submissions';
import { call, put } from 'redux-saga/effects';
import { takeLatest, takeEvery } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { browserHistory } from 'react-router';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { spaceToUnderscore } from "../helpers/helpers";
import _ from 'lodash';


export function* doRequestCreateSubmission(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'submissions.doRequestCreateSubmission'
        }
    });

    try {
        const submission = yield call(api.createSubmission, action.payload.submission);

        yield put({
            type: types.SUBMISSION__CREATE__REQUESTED__SUCCEEDED,
            payload: { submission }
        });
    } catch (e) {
        yield put({
            type: types.SUBMISSION__CREATE__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'submissions.doRequestCreateSubmission'
        }
    });

    yield put(hideLoading());
}

export function* doRequestCreateSubmissionSucceeded(action) {
    const { submission } = action.payload;

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'submissions.doRequestCreateSubmission'
        }
    });

    yield put({
        type: types.ASSIGNMENT__MEMBERSHIPS__REQUESTED,
        payload:{
            assignmentId: submission.assignment.id
        }
    });

    yield put({
        type: types.ASSIGNMENT__SUBMISSIONS__REQUESTED,
        payload:{
            assignmentId: submission.assignment.id
        }
    });
}

export function* doRequestCreateSubmissionFailed(action) {
    const { assignment } = action.payload;

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestCreateSubmission'
        }
    });

    yield put({
        type: types.ASSIGNMENT__MEMBERSHIPS__REQUESTED,
        payload:{
            assignmentId: assignment.id
        }
    });

    yield put({
        type: types.ASSIGNMENT__SUBMISSIONS__REQUESTED,
        payload:{
            assignmentId: assignment.id
        }
    });
}

export function* doRequestUpdateSubmission(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateSubmission'
        }
    });

    try {
        const submission = yield call(api.updateSubmission, action.payload.submission);

        yield put({
            type: types.SUBMISSION__UPDATE__REQUESTED__SUCCEEDED,
            payload: { submission }
        });
    } catch (e) {
        yield put({
            type: types.SUBMISSION__UPDATE__REQUESTED__FAILED,
            message: e.message,
            data: e.data
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateSubmission'
        }
    });

    yield put(hideLoading());

}

export function* doRequestUpdateSubmissionSucceeded(action) {
    const { submission } = action.payload;

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateSubmission'
        }
    });

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Submission updated successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.ASSIGNMENT__MEMBERSHIPS__REQUESTED,
        payload:{
            assignmentId: submission.assignment.id
        }
    });

    yield put({
        type: types.ASSIGNMENT__SUBMISSIONS__REQUESTED,
        payload:{
            assignmentId: submission.assignment.id
        }
    });
}

export function* doRequestUpdateSubmissionFailed(action) {
    const { data } = action;

    let { message } = action;

    if (data && data.errors &&
        _.some(
            data.errors,
            (error) => {
                return error.indexOf('has been updated') > -1;
            }
        )
    ) {
        message = 'Submission has been updated.  Please Refresh.';
    }

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error updating submission. ${message}`,
            level: 'error',
            autoDismiss: 0
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateSubmission'
        }
    });
}

export function* doRequestUpdateNotDoneSubmission(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateNotDoneSubmission'
        }
    });

    try {
        const submission = yield call(api.updateSubmission, action.payload.submission);

        yield put({
            type: types.SUBMISSION__UPDATE__NOTDONE__REQUESTED__SUCCEEDED,
            payload: { submission }
        });
    } catch (e) {
        yield put({
            type: types.SUBMISSION__UPDATE__NOTDONE__REQUESTED__FAILED,
            message: e.message,
            data: e.data
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateNotDoneSubmission'
        }
    });

    yield put(hideLoading());
}

export function* doRequestUpdateNotDoneSubmissionSucceeded(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Submission updated successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateNotDoneSubmission'
        }
    });
}

export function* doRequestUpdateNotDoneSubmissionFailed(action) {
    const { data } = action;

    let { message } = action;

    if (data && data.errors &&
        _.some(
            data.errors,
            (error) => {
                return error.indexOf('has been updated') > -1;
            }
        )
    ) {
        message = 'Submission has been updated.  Please Refresh.';
    }

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error updating submission. ${message}`,
            level: 'error',
            autoDismiss: 0,
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestUpdateNotDoneSubmission'
        }
    });
}

export function* doRequestConfirmSubmission(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestConfirmSubmission'
        }
    });

    try{
        const submission = yield call(api.updateSubmission, action.payload.submission);

        yield put({
            type: types.SUBMISSION__CONFIRMATION__REQUESTED__SUCCEEDED,
            payload: { submission }
        });
    } catch (e) {
        yield put({
            type: types.SUBMISSION__CONFIRMATION__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestConfirmSubmission'
        }
    });

    yield put(hideLoading());
}

export function* doRequestConfirmSubmissionSucceeded(action) {
    const { submission } = action.payload;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Group membership confirmed successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'submissions.doRequestConfirmSubmission'
        }
    });

    yield put({
        type: types.ASSIGNMENT__MEMBERSHIPS__REQUESTED,
        payload:{
            assignmentId: submission.assignment.id
        }
    });

    yield put({
        type: types.ASSIGNMENT__SUBMISSIONS__REQUESTED,
        payload:{
            assignmentId: submission.assignment.id
        }
    });
}

export function* doRequestConfirmSubmissionFailed(action) {
    const { data } = action;

    let { message } = action;

    if (data && data.errors &&
        _.some(
            data.errors,
            (error) => {
                return error.indexOf('has been updated') > -1;
            }
        )
    ) {
        message = 'Submission has been updated.  Please Refresh.';
    }

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: `Error confirming group membership. ${message}`,
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestConfirmSubmission'
        }
    });
}

export function* doRequestDropboxUserSubmissions(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'submissions.doRequestDropboxUserSubmissions'
            }
        });

        const { dropboxId, userId } = action.payload,
            submissions = yield call(api.fetchDropboxUserSubmissions, dropboxId, userId)
        ;

        yield put({
            type: types.DROPBOX__USER__SUBMISSIONS__REQUESTED__SUCCEEDED,
            payload: {
                submissions,
                dropbox: dropboxId,
                user: userId
            }
        });
    } catch (e) {
        yield put({
            type: types.DROPBOX__USER__SUBMISSIONS__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'submissions.doRequestDropboxUserSubmissions'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDropboxUserSubmissionsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'submissions.doRequestDropboxUserSubmissions'
        }
    });
}

export function* doRequestDropboxUserSubmissionsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestDropboxUserSubmissions'
        }
    });
}

export function* doRequestAssignmentSubmissions(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'submissions.doRequestAssignmentSubmissions'
            }
        });

        const submissions = yield call(api.fetchAssignmentSubmissions, action.payload.assignmentId);

        yield put({
            type: types.ASSIGNMENT__SUBMISSIONS__REQUESTED__SUCCEEDED,
            payload: {
                submissions,
                assignment: action.payload.assignmentId,
            },
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__SUBMISSIONS__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'submissions.doRequestAssignmentSubmissions'
        }
    });

    yield put(hideLoading());
}

export function* doRequestAssignmentSubmissionsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'submissions.doRequestAssignmentSubmissions'
        }
    });
}

export function* doRequestAssignmentSubmissionsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'submissions.doRequestAssignmentSubmissions'
        }
    });
}

export function* doRequestDropboxAssignmentSubmission(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'assignments.doRequestDropboxAssignmentSubmission'
            }
        });

        const { assignmentName, dropboxName} = action.payload,
            submission = yield call(api.fetchDropboxAssignmentSubmission, dropboxName, assignmentName)
        ;

        yield put({
            type: types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__SUCCEEDED,
            payload: { submission }
        });

    } catch (e) {
        yield put({
            type: types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'assignments.doRequestDropboxAssignmentSubmission'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDropboxAssignmentSubmissionSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'assignments.doRequestDropboxAssignmentSubmission'
        }
    });
}

export function* doRequestDropboxAssignmentSubmissionFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'assignments.doRequestDropboxAssignmentSubmission'
        }
    });
}

export function* watchRequestAssignmentSubmissions() {
    yield* takeLatest(types.ASSIGNMENT__SUBMISSIONS__REQUESTED, doRequestAssignmentSubmissions);
}

export function* watchRequestAssignmentSubmissionsSucceeded() {
    yield* takeLatest(types.ASSIGNMENT__SUBMISSIONS__REQUESTED__SUCCEEDED, doRequestAssignmentSubmissionsSucceeded);
}

export function* watchRequestAssignmentSubmissionsFailed() {
    yield* takeLatest(types.ASSIGNMENT__SUBMISSIONS__REQUESTED__FAILED, doRequestAssignmentSubmissionsFailed);
}

export function* watchRequestDropboxUserSubmissions() {
    yield* takeLatest(types.DROPBOX__USER__SUBMISSIONS__REQUESTED, doRequestDropboxUserSubmissions);
}

export function* watchRequestDropboxUserSubmissionsSucceeded() {
    yield* takeLatest(types.DROPBOX__USER__SUBMISSIONS__REQUESTED__SUCCEEDED, doRequestDropboxUserSubmissionsSucceeded);
}

export function* watchRequestDropboxUserSubmissionsFailed() {
    yield* takeLatest(types.DROPBOX__USER__SUBMISSIONS__REQUESTED__FAILED, doRequestDropboxUserSubmissionsFailed);
}

export function* watchRequestCreateSubmission() {
    yield* takeEvery(types.SUBMISSION__CREATE__REQUESTED, doRequestCreateSubmission);
}

export function* watchRequestCreateSubmissionSucceeded() {
    yield* takeLatest(types.SUBMISSION__CREATE__REQUESTED__SUCCEEDED, doRequestCreateSubmissionSucceeded);
}

export function* watchRequestCreateSubmissionFailed() {
    yield* takeLatest(types.SUBMISSION__CREATE__REQUESTED__FAILED, doRequestCreateSubmissionFailed);
}

export function* watchRequestUpdateSubmission() {
    yield* takeLatest(types.SUBMISSION__UPDATE__REQUESTED, doRequestUpdateSubmission);
}

export function* watchRequestUpdateSubmissionSucceeded() {
    yield* takeLatest(types.SUBMISSION__UPDATE__REQUESTED__SUCCEEDED, doRequestUpdateSubmissionSucceeded);
}

export function* watchRequestUpdateSubmissionFailed() {
    yield* takeLatest(types.SUBMISSION__UPDATE__REQUESTED__FAILED, doRequestUpdateSubmissionFailed);
}

export function* watchRequestUpdateNotDoneSubmission() {
    yield* takeLatest(types.SUBMISSION__UPDATE__NOTDONE__REQUESTED, doRequestUpdateNotDoneSubmission);
}

export function* watchRequestUpdateNotDoneSubmissionSucceeded() {
    yield* takeLatest(types.SUBMISSION__UPDATE__NOTDONE__REQUESTED__SUCCEEDED, doRequestUpdateNotDoneSubmissionSucceeded);
}

export function* watchRequestUpdateNotDoneSubmissionFailed() {
    yield* takeLatest(types.SUBMISSION__UPDATE__NOTDONE__REQUESTED__FAILED, doRequestUpdateNotDoneSubmissionFailed);
}

export function* watchRequestConfirmSubmission() {
    yield* takeLatest(types.SUBMISSION__CONFIRMATION__REQUESTED, doRequestConfirmSubmission);
}

export function* watchRequestConfirmSubmissionSucceeded() {
    yield* takeLatest(types.SUBMISSION__CONFIRMATION__REQUESTED__SUCCEEDED, doRequestConfirmSubmissionSucceeded);
}

export function* watchRequestConfirmSubmissionFailed() {
    yield* takeLatest(types.SUBMISSION__CONFIRMATION__REQUESTED__FAILED, doRequestConfirmSubmissionFailed);
}

export function* watchRequestDropboxAssignmentSubmission() {
    yield* takeLatest(types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED, doRequestDropboxAssignmentSubmission);
}

export function* watchRequestDropboxAssignmentSubmissionSucceeded() {
    yield* takeLatest(types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__SUCCEEDED, doRequestDropboxAssignmentSubmissionSucceeded);
}

export function* watchRequestDropboxAssignmentSubmissionFailed() {
    yield* takeLatest(types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__FAILED, doRequestDropboxAssignmentSubmissionFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/submissions.saga.js
 **/